import { useUser } from "@/composables/user/user";

export function useSsoAccessToken() {
  return useUser().ssoAccessToken;
}
